export enum BillingMethodType {
    ChargePayment = 'Charge Payment',
    RequestPayment = 'Request Payment',
}

export enum EditBillingMethodType {
    UseExistingPayment = 'Use Existing',
    CreateNewPayment = 'Create New',
}

export enum NewPaymentRelatedSource {
    Manual = 'Manual',
    Subscription = 'Subscription',
    Invoice = 'Invoice',
    CheckOut = 'CheckOut',
    PurchaseLinks = 'PurchaseLinks',
}

export enum UpsertPurchaseActiveStep {
    Purchase = 'Purchase',
    AddOn = 'AddOn',
    Options = 'Options',
    Payment = 'Payment',
    Success = 'Success',
}
export enum AccountTypes {
    Personal = 'Personal',
    Savings = 'Savings',
    Joint = 'Joint',
}
